import { render, staticRenderFns } from "./UpdateRegionalManager.vue?vue&type=template&id=0a726c06&scoped=true&"
import script from "./UpdateRegionalManager.vue?vue&type=script&lang=js&"
export * from "./UpdateRegionalManager.vue?vue&type=script&lang=js&"
import style0 from "./UpdateRegionalManager.vue?vue&type=style&index=0&id=0a726c06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a726c06",
  null
  
)

export default component.exports